<template>
  <responsive-drawer-header
    :badgeColor="'primary'"
    :moduleUnreadCount="unreadCountByModuleInstance[$route.params.instance]"
    :color="theme.appBar.other.color"
    :headerBg="theme.appBar.other.bg"
    :hasDrawer="false"
  >
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>

    <template v-slot:left-subtitle>
      <div v-if="video" class="d-flex caption">
        {{ video.title }}
      </div>
      <div v-else class="d-flex caption">{{ $t('videos') }}</div>
    </template>

    <template v-slot:right v-if="video">
      <share-button v-if="!smAndDown" :file="video" :moduleBackendId="moduleBackendId" :color="color"></share-button>
      <acknowledge-button
        v-if="!smAndDown && isToAcknowledge"
        :document="video"
        :color="color"
        :documentTitle="video.title"
        :moduleType="moduleType"
      ></acknowledge-button>
      <v-btn :color="theme.appBar.other.color" text rounded @click="back()"> <v-icon class="mr-2">mdi-close</v-icon>{{ $t('close') }} </v-btn>
      <v-menu v-if="smAndDown" style="min-width: 250px" left bottom transition="slide-y-transition" offset-y close-on-content-click>
        <template v-slot:activator="{ on, attrs }">
          <v-btn :color="color" fab class="d-flex" icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <share-button v-if="smAndDown" listItem :file="video" :moduleBackendId="moduleBackendId" :color="color"></share-button>
          <toggle-read-button v-if="mdAndDown" type="watch" listItem :item="video" :color="color"></toggle-read-button>
          <!-- <acknowledge-button
                      listItem
                      v-if="!smAndDown && isToAcknowledge"
                      :documentTitle="vidoe.title"
                      :document="video"
                      :moduleType="moduleType"
                    ></acknowledge-button> -->
        </v-list>
      </v-menu>
    </template>
  </responsive-drawer-header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import common from '@/mixins/common';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import ShareButton from '@/components/buttons/ShareButton.vue';
import ToggleReadButton from '@/components/buttons/ToggleReadButton.vue';
import acknowledgeService from '@/services/acknowledgeService';
import dateUtils from '@/common/dateUtils';
import module from './index';

export default {
  mixins: [common],
  components: {
    ResponsiveDrawerHeader,
    ShareButton,
    ToggleReadButton,
  },
  computed: {
    ...mapState('videos', ['videosById', 'groups', 'selectedGroup', 'dataLoaded', 'unreadCountByModuleInstance']),
    ...mapGetters('videos', ['sortedAndFilteredGroups']),

    video() {
      return this.videosById[this.$route.params.videoId];
    },
    moduleType: () => module.moduleType,
    moduleBackendId: () => module.api,
    streamedTime() {
        if (!this.video || !this.video.anzeige_von) return '';
        const formattedDate = new Date(this.video.anzeige_von).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
        return `Shared on ${formattedDate}`;
    },
    selectedGroup: {
      get() {
        return this.$store.state.videos.selectedGroup;
      },
      set(value) {
        if (value !== this.$store.state.videos.selectedGroup) {
          console.debug('value', value);
          this.$store.commit('videos/setSelectedGroup', value);
        }
      },
    },
    hasGroupFilterInHeader() {
      if (this.xs) return false;
      return this.sortedAndFilteredGroups.length < 4;
    },
    color() {
      return this.theme.appBar.other.color;
    },
    isToAcknowledge() {
      return acknowledgeService.isToAcknowledge(this.video);
    },
  },
  methods: {
    /** Back to news base view */
    back() {
      this.$router.push({ name: 'videos' });
    },
    markAsRead() {
      console.debug('markAsRead', this.video);
      if (this.video) {
        let sendboxTitle = this.$t('action.video.seen.msg', { title: this.video.title });
        let snackbarText = this.$t('action.video.read');
        this.$store.dispatch(
          `sendbox/markAsRead2`,
          {
            item: this.video,
            sendboxTitle,
            snackbarText,
            immediate: true,
          },
          { root: true }
        );
        // this.$store.dispatch(`sendbox/markAsRead`, { item: this.video, immediate: true });
      }
    },
    markAsUnread() {
      if (this.video) {
        let sendboxTitle = this.$t('action.video.seen.msg', { title: this.video.title });
        let snackbarText = this.$t('action.video.read');
        this.$store.dispatch(
          `sendbox/markAsUnread2`,
          {
            item: this.video,
            sendboxTitle,
            snackbarText,
            immediate: true,
          },
          { root: true }
        );
        // this.$store.dispatch(`sendbox/markAsUnread`, { item: this.video });
      }
    },
  },
};
</script>
